import React, { useState, useEffect, useContext } from 'react';
import Loading from '../Loading';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation, useHistory } from "react-router-dom";
import ScheduleBox from './ScheduleBox';
import { scheduleTemplateKeys } from '../../api';
import { somethingWentWrongNotice } from '../UI/Notifications';
import { UserContext } from 'context/User';

const ScheduleTemplateCreate = ({ setTrigger, trigger }) => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const query = useQuery();
  const type = query.get("type");
  const [loading, setLoading] = useState(false);
  const [templateKeys, setTemplateKeys] = useState({});
  const history = useHistory();
  const title = type === 'email' && 'Create Schedule Email' || type === 'sms' && 'Create Schedule SMS'; 

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Inbox");
    }
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    switch (type) {
      case 'email':
        scheduleTemplateKeysRequest()
        break;
      case 'sms':
        scheduleTemplateKeysRequest()
        break;
      default:
        setLoading(false);
    }
    setTrigger(!trigger);
  }, []);


  const scheduleTemplateKeysRequest = () => {
    scheduleTemplateKeys()
      .then(response => {
        setTemplateKeys(response.data);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setLoading(false);
      })
  }

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5">
              {title}
            </h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <ScheduleBox 
              templateKeys={templateKeys}
              type={type}
              handleDefaultStatusCodes={handleDefaultStatusCodes}
              setLoading={setLoading}
            />
          </Col>
        </Row>
      </Container>
      {loading && <Loading />}
    </section>  
  )
}

export default ScheduleTemplateCreate;